import {useState} from 'react';
import http from '../http';
import {useNavigate} from 'react-router-dom';

export default function Create(){
    const navigate=useNavigate();
    // const [users, setUsers] = useState([]);
const [inputs,setInputs] = useState({});
    const handlechange = (event) =>{
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values,[name]:value}))
    }

    const submitForm = () =>{
        // console.log(inputs)
        http.post('/users',inputs).then((res)=>{
            navigate('/login');
             
        })
    }

    return (
        <div>
            <h1>Enter The Details</h1>
            <div className='row'>
            <div className='col-sm-6 justify-content-center'>
                <div className='card p-4'>
                <label>Name</label>
                <input type='text' name='name' className='form-control mb-2' 
                value={inputs.name || ''}
                onChange={handlechange} />
                <label>Email</label>
                <input type='email' name='email' className='form-control mb-2'
                value={inputs.email || ''}
                onChange={handlechange} />
                <label>Phone</label>
                <input type='tel' name='phone' className='form-control mb-2' 
                value={inputs.phone || ''}
                onChange={handlechange}/>
                <label>Password</label>
                <input type='password' name='password' className='form-control mb-2'
                value={inputs.password || ''}
                onChange={handlechange} />
                <button type="button" onClick={submitForm} className='btn btn-info mt-2'>Register</button>
            </div>
            </div>
            </div>
        </div>
    )
}